import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import carScanAiDocumentQuery from './carScanAiDocumentQuery.graphql';
import CarScanAiDocumentManagement from '../../../components/siteadmin/CarScanAiDocumentManagement/CarScanAiDocumentManagement';
import s from './CarScanAiDocumentList.css';




// Container component
class CarScanAiDocumentList extends React.Component {
  static propTypes = {
     title: PropTypes.string.isRequired,
     reservationId: PropTypes.number.isRequired,
    carScanAiDocumentQuery: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      getCarScanAiPhotoList: PropTypes.array,
    }),
  };

  render() {
    const { getCarScanAiPhotoList: carScanAiDocumentQuery, title, reservationId } = this.props;
    // carScanAiDocumentQuery may be undefined briefly; default to empty object
    const { loading, error, getCarScanAiPhotoList } = carScanAiDocumentQuery || {};
    // Pass as named props for clarity

    console.log(getCarScanAiPhotoList, 'getCarScanAiPhotoList');
    return <CarScanAiDocumentManagement data={{ loading, error, getCarScanAiPhotoList }} title={title} reservationId={reservationId}/>;
  }
}

export default compose(
  withStyles(s),
  graphql(carScanAiDocumentQuery, {
    name: 'getCarScanAiPhotoList',
    options: (props) => {
      // ReservationId is expected as a prop (from route params)
          const { reservationId } = props;
      const variables = reservationId !== undefined
        ? { reservation_id: reservationId }
        : {};
      return {
        variables,
        fetchPolicy: 'network-only',
      };
    }
  })
)(CarScanAiDocumentList);

